// ============================================
// モジュール読み込み
// ============================================
import initCommonScript from "./libs/common";
import initAnimation from "./libs/animation";

// 共通script
initCommonScript();

// アニメーションscript
initAnimation();
